<div class="d-flex flex-column main min-vh-100">
  <div
    class="position-fixed top-0 start-0 end-0 shadow-sm"
    style="z-index: 9999"
  >
    <app-header *ngIf="isLoggedIn"></app-header>
  </div>
  <div class="placeholder"></div>
  <app-campaign-banner *ngIf="isHomePage"></app-campaign-banner>
  <main class="container-fluid px-4 flex-fill">
    <router-outlet></router-outlet>
  </main>

  <app-footer *ngIf="isLoggedIn"></app-footer>

  <notifier-container></notifier-container>
  <app-call-support-action-button></app-call-support-action-button>
</div>
